import React from 'react';
import "./Contact.css";
import ButtonMailto from './ButtonMailTo';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faStudiovinari } from '@fortawesome/free-brands-svg-icons';
import ContactImage from './people-who-support-svgrepo-com.svg'

function Contact() {
    const submitToPandora = () => {
        return "mailto:pandoraincstudios@gmail.com";
    };

    
  return (
    <div className='pandora-contact'>
        <h5>Get in touch with us! </h5>
        {/* form here */}
        <form onSubmit={submitToPandora} className='pandora-form'>
            {/* <input className='pandora-email' type="email" placeholder="Email to keep in touch" />
            <input className='pandora-name' type="text" placeholder="Enter Name" />
            <textarea className='pandora-textarea' rows="10" cols="60" placeholder="Give us a brief description of the product to be built.">

            </textarea>
            <input className='pandora-submit' type="submit" /> */}

        {/* <FontAwesomeIcon icon={faStudiovinari} size="6x" /> */}
        <img src={ContactImage} alt="Pandora Team Image" className="pandora-pontact" />


          <ButtonMailto label="Write us an E-Mail" mailto="mailto:pandoraincstudios@gmail.com" />


        </form>

    </div>
  )
}

export default Contact;

